module.exports = __webpack_public_path__ + "img/easydek_gelegd.afd2b51b.jpg";